<!--
  Footer bar
-->

<template lang="html">
  <footer id="footer">
    <div class="container">
      <div class="row">
        <div class="col-xs-6">
          <img
            class="footer-logo"
            src="static/img/common/newlogo_black.png"
            type="image/svg+xml"
          />
          <label v-html="footer.copy"></label>
        </div>

        <div class="col-xs-6 footer-social-icons">
          <ul>
            <li v-for="(contact, index) in contact.array">
              <a :href="contact.link" target="_blank">
                <div class="block-button social-button">
                  <div class="mybutton-up"><i :class="contact.class"></i></div>
                  <div class="mybutton-down">
                    <i :class="contact.class"></i>
                  </div>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { contact, footer } from "../../content.json";

export default {
  name: "footbar",
  data: function () {
    return {
      contact,
      footer,
    };
  },
};
</script>

<style>
footer {
  /*    border-top: 1px solid rgba(246,217,211,1);*/
  padding: 30px 0;
  background-color: #cae8dc;
  font-family: "univers", "Helvetica", sans-serif;
  /*    border-top: 3px solid #000;*/
}
footer p {
  line-height: 16px;
  margin-top: 10px;
}
footer span {
  font-size: 18px;
  margin-top: 86px;
  float: right;
}
.footer-bar {
  width: 100%;
  position: absolute;
  top: 0;
}
.footer-block {
  width: 20%;
  height: 5px;
  float: left;
}

.footer-logo {
  height: 30px;
  width: auto;
  width: auto;
  fill: #fff;
  display: block;
  position: relative;
}

.footer-logo path {
  fill: #fff !important;
}

.footer-social-icons ul {
  margin: 0px auto 0;
  padding: 0;
  list-style: none;
  text-align: right;
}

.footer-social-icons li {
  display: inline-block;
  list-style: none;
  margin: 0 0px 0 10px;
}
.footer-social-icons li img {
  width: 26px;
  -webkit-transition: 0.2s ease-in-out;
  transition: 0.2s ease-in-out;
}

.footer-social-icons li {
  text-align: center;
}
.no-touch-device .footer-social-icons img:hover {
  opacity: 0.7;
}
footer label {
  margin: 5px 0 0;
  font-size: 13px;
  font-weight: 300;
  color: #000;
}

@media (min-width: 768px) {
  .footer-social-icons ul {
    margin: 0 auto;
  }
  footer {
    padding: 50px 0;
  }
  .footer-social-icons ul {
    text-align: right;
    margin-top: 0;
  }
  .footer-social-icons li {
    margin: 0 0 0 20px;
  }
  .footer-logo {
    height: 40px;
    width: 185px;
  }

  footer label {
    margin: 10px 0 0;
    font-size: 16px;
  }
}

@media (max-width: 374px) {
  .footer-social-icons .social-icon {
    height: 24px;
    width: 24px;
    padding: 4px;
  }
}
</style>
